import API from "../authentication/AuthInterceptor";

export class DistributorService {
  async getDistributorById(distributorId: string) {
    const resposne = await API.get(`/distributor/${distributorId}`);
    return resposne.data;
  }

  async getPartnerConfig(partnerId: string) {
    const respone = await API.get(`/partner/config/${partnerId}`);
    return respone.data;
  }

  async sendFeedback(feedback: any) {
    await API.post(`/merchantDashboard/feedback`, feedback);
  }
}
